import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import {
  ViewProviders,
  ElderTableComponent,
  ElderFormFieldDenseDirective,
  ElderQuantityInputControlComponent,
  ElderValidationErrorDirective,
  ElderDurationInputComponent,
} from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { ProcessingTime } from '../processing-time'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { FormsModule } from '@angular/forms'
import { MatFormField, MatError } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort } from '@angular/material/sort'

@Component({
  selector: 'app-processing-time-variant-table',
  templateUrl: './processing-time-variant-table.component.html',
  styleUrls: ['./processing-time-variant-table.component.scss'],
  viewProviders: [ViewProviders.ParentControlContainer],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatFormField,
    ElderFormFieldDenseDirective,
    ElderQuantityInputControlComponent,
    FormsModule,
    MatError,
    ElderValidationErrorDirective,
    MatTooltip,
    ElderDurationInputComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ProcessingTimeVariantTableComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _processingTimes$: BehaviorSubject<ProcessingTime[]> = new BehaviorSubject<
    ProcessingTime[]
  >([])

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public name: string

  public get processingTimes$(): Observable<ProcessingTime[]> {
    return this._processingTimes$.asObservable()
  }

  public get processingTimes(): ProcessingTime[] {
    return this._processingTimes$.getValue()
  }

  @Input()
  public set variantSets(variantSets: ProcessingTime[][]) {
    const pTimes: ProcessingTime[] = []
    if (variantSets) {
      for (let i = 0; i < variantSets.length; i++) {
        variantSets[i].forEach((p) => (p.setNumber = i + 1)) // TODO: remove mutation
      }

      variantSets.forEach((vs) => pTimes.push(...vs))
    }

    this._processingTimes$.next(pTimes)
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
